import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "setValue", "readonly", "placeholder", "config"];
import React from "react";
import { NumericFormat } from "react-number-format";
import { Input } from "antd";
export default (function (props) {
  var value = props.value,
    setValue = props.setValue,
    readonly = props.readonly,
    placeholder = props.placeholder,
    config = props.config,
    numericFormatProps = _objectWithoutProperties(props, _excluded);
  var handleChange = function handleChange(values) {
    var val = values.floatValue;
    setValue(val === undefined ? null : val);
  };
  var renderSize = config.settings.renderSize;
  return /*#__PURE__*/React.createElement(NumericFormat, _extends({
    customInput: Input,
    type: "text",
    size: renderSize,
    value: value,
    placeholder: placeholder,
    disabled: readonly,
    onValueChange: handleChange
  }, numericFormatProps));
});